module.exports = __webpack_public_path__ + "static/cc-exp-8b12ddebb19ce358b20310a1bf80d668.svg";